<template>
  <v-snackbar
    v-model="$snackbar.enabled"
    :color="$snackbar.color"
    :multi-line="$snackbar.multiline"
    :timeout="-1"
    :vertical="$snackbar.vertical"
  >
    <p v-for="(message, i) in $snackbar.messages" :key="i">
      {{ message }}
    </p>
    <template v-slot:actions>
      <v-btn variant="text" @click.prevent="$snackbar.reset()"> Fechar </v-btn>
    </template>
  </v-snackbar>
</template>

<script setup>
// Snackbar component for displaying notifications
// Uses Vuetify 3 snackbar with actions slot
</script>
